import * as React from 'react'
import ErrorBoxComponent from '../../../shared/error-box.component'
import CesuPriceableFormComponent from '../../cesu-priceable/cesu-priceable-form.component'
import { CesuQuotationBase } from '../../../../services/json-schemas/base/cesu_quotation'
import { CesuMileageReimbursementBase } from '../../../../services/json-schemas/base/cesu_mileage_reimbursement'
import { MarketplaceBase } from '../../../../services/json-schemas/base/marketplace'
import { QuotationBase } from '../../../../services/json-schemas/base/quotation'
import QuotationDescriptionInputComponent from './quotation-description-input.component'
import { OfferedServiceBase } from '../../../../services/json-schemas/base/offered_service'
import { I18nService } from '../../../../services/utils/i18n.service'

interface Props {
  castingMarket: Pick<MarketplaceBase, 'currency'>
  offeredService: Pick<OfferedServiceBase, 'description_plain_text'>
  quotation: Pick<QuotationBase, 'description'> & {
    cesu_quotation_attributes: Pick<CesuQuotationBase, 'id' | 'management_fee_with_taxes_cents' | 'raw_employee_hourly_salary_cents' | 'employer_charge_percentage' | 'charge_exemption' | 'estimated_monthly_hours' | 'rest_week_day' | 'rest_week_day_worked_paid' | 'high_value_day_offs' | 'day_off_increase_percentage' | 'weekend_increase_percentage' | 'weekend_incluses_saturday' | 'apply_increases_to_management_fees'> & {
      cesu_mileage_reimbursement_attributes: Pick<CesuMileageReimbursementBase, 'id' | 'amount_cents' | 'applyness' | 'show_on_document'> & { _destroy?: boolean } | null
    }
  }
  onChange: React.Dispatch<React.SetStateAction<Partial<Props['quotation']>>>
}

const i18nScoped = new I18nService(require('./quotation-form-enable-employee-of-customer.component.yml'))

export default function QuotationFormEnableEmployeeOfCustomerComponent ({ castingMarket, offeredService, quotation, onChange }: Props) {
  const [estimationErrors, setEstimationErrors] = React.useState<string[]>([])

  const setCesuQuotationState = React.useCallback((partial: Partial<Props['quotation']['cesu_quotation_attributes']>) => {
    onChange(quotation => ({ ...quotation, cesu_quotation_attributes: { ...quotation.cesu_quotation_attributes, ...partial } }))
  }, [onChange]) // should only rely on store for immutable reference, required by CesuPricingFormComponent
  
  return <>
    <ErrorBoxComponent fullMessages={ estimationErrors } />

    <CesuPriceableFormComponent object={ quotation.cesu_quotation_attributes } setObjectState={ setCesuQuotationState } market={ castingMarket } setEstimationErrors={ setEstimationErrors }>
      { ({ managementFeeField, salaryField, estimationBlock, additionalCompensationsField, mileageReimbursementBlock }) => <>
        { managementFeeField }
        { salaryField }
        { estimationBlock }

        <div className="u-borderT u-mts u-mbm" />
        <div className='u-mbs'>{ additionalCompensationsField }</div>
        { mileageReimbursementBlock }
      </> }
    </CesuPriceableFormComponent>

    <QuotationDescriptionInputComponent
      className="u-mtm"
      description={ quotation.description }
      offeredServiceDescriptionPlainText={ offeredService.description_plain_text }
      placeholder={ i18nScoped.t('description_placeholder') }
      rows={ 3 }
      onChange={ description => onChange({ description }) } />
  </>
}